import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "modal", "text"]

  connect() {
    Turbo.config.forms.confirm = (message) => {
      this.textTarget.textContent = message;
      this.open();
      return new Promise((resolve) => {
        this.element.addEventListener("close", (event) => {
          resolve(event.detail?.value === "confirmed");
        }, { once: true });
      });
    }
  }

  disconnect() {
    Turbo.config.forms.confirm = null;
  }

  confirm() {
    this.element.dispatchEvent(new CustomEvent("close", { detail: { value: "confirmed" } }));
    this.close();
  }

  cancel() {
    this.element.dispatchEvent(new CustomEvent("close", { detail: { value: "cancelled" } }));
    this.close();
  }

  close () {
    this.modalTarget.close()
  }

  open() {
    this.modalTarget.showModal()
  }
}
